// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eliminate-paper-block {
  width: 100%;
  border-radius: 20px;
  background-color: #040e46;
  display: flex;
  margin-top: 20px;
}
.eliminate-paper-block .eliminate-paper-card {
  height: 144px;
  width: 120px;
  background-color: #fff;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  border-radius: 10px;
  padding: 24px 15px;
  text-align: center;
  position: absolute;
}
.eliminate-paper-block .eliminate-paper-card .eliminate-paper-card-text {
  margin-top: 6px;
  text-align: center;
}
.eliminate-paper-block .eliminate-paper-left-block {
  width: 25%;
  position: relative;
}
.eliminate-paper-block .eliminate-paper-left-block .eliminate-paper-left-svg {
  width: 100%;
  height: auto;
}
.eliminate-paper-block .eliminate-paper-left-block .eliminate-paper-customize-processes-card {
  z-index: 1;
  bottom: -20px;
  left: 41.2%;
  transform: rotate(-8deg);
}
.eliminate-paper-block .eliminate-paper-left-block .eliminate-paper-customize-processes-card svg {
  transform: rotate(8deg);
}
.eliminate-paper-block .eliminate-paper-left-block .eliminate-paper-staff-education-card {
  z-index: 2;
  bottom: 76px;
  left: 68.5%;
  transform: rotate(-3deg);
}
.eliminate-paper-block .eliminate-paper-left-block .eliminate-paper-staff-education-card svg {
  transform: rotate(3deg);
}
.eliminate-paper-block .eliminate-paper-center-block {
  width: 50%;
  padding: 100px 40px;
  color: #fff;
  text-align: center;
}
.eliminate-paper-block .eliminate-paper-center-block .eliminate-paper-title {
  font-size: 46px;
  font-weight: 600;
  line-height: 120%;
}
.eliminate-paper-block .eliminate-paper-center-block .eliminate-paper-subtitle {
  margin-top: 24px;
  font-size: 24px;
  font-weight: 400;
  line-height: 180%;
}
.eliminate-paper-block .eliminate-paper-center-block .request-demo-btn {
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
  background-color: #3571d6;
  border-radius: 8px;
  width: 200px;
  height: 45px;
  border: none;
  border-bottom: 2px solid #040e46;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  padding: 12px 24px 12px 24px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  display: flex;
  align-items: center;
}

.eliminate-paper-right-block {
  width: 25%;
  display: flex;
  align-items: end;
  position: relative;
}
.eliminate-paper-right-block .eliminate-paper-right-svg {
  width: 100%;
  height: auto;
}
.eliminate-paper-right-block .eliminate-paper-compliance-card {
  top: -43px;
  left: 0;
  transform: rotate(-7deg);
  z-index: 2;
}
.eliminate-paper-right-block .eliminate-paper-compliance-card svg {
  transform: rotate(7deg);
}
.eliminate-paper-right-block .eliminate-paper-file-card {
  top: 45px;
  left: 30%;
  z-index: 3;
  transform: rotate(2deg);
}
.eliminate-paper-right-block .eliminate-paper-file-card svg {
  transform: rotate(-2deg);
}

.eliminate-paper-block.isMobile {
  position: relative;
}
.eliminate-paper-block.isMobile .eliminate-paper-card {
  width: 110px;
  height: auto;
  padding: 18px 12px;
}
.eliminate-paper-block.isMobile .eliminate-paper-card.eliminate-paper-customize-processes-card {
  left: 23.43%;
  bottom: -14px;
  transform: rotate(-8deg);
}
.eliminate-paper-block.isMobile .eliminate-paper-card.eliminate-paper-staff-education-card {
  left: 49%;
  bottom: 35px;
  transform: rotate(-3deg);
}
.eliminate-paper-block.isMobile .eliminate-paper-card.eliminate-paper-compliance-card {
  left: 22%;
  top: -14px;
  transform: rotate(-7deg);
}
.eliminate-paper-block.isMobile .eliminate-paper-card.eliminate-paper-file-card {
  left: 50%;
  top: 14px;
  transform: rotate(2deg);
}
.eliminate-paper-block.isMobile .eliminate-paper-left-block {
  position: absolute;
  bottom: 0;
  text-align: right;
  width: 100%;
}
.eliminate-paper-block.isMobile .eliminate-paper-left-block .eliminate-paper-left-svg {
  width: unset;
  height: 200px;
}
.eliminate-paper-block.isMobile .eliminate-paper-center-block {
  padding: 167px 20px 0px 20px;
  width: 100%;
}
.eliminate-paper-block.isMobile .eliminate-paper-center-block .eliminate-paper-title {
  font-size: 36px;
  line-height: 120%;
}
.eliminate-paper-block.isMobile .eliminate-paper-center-block .eliminate-paper-subtitle {
  font-size: 20px;
  line-height: 160%;
}
.eliminate-paper-block.isMobile .eliminate-paper-center-block .request-demo-btn {
  margin-top: 40px;
  margin-bottom: 200px;
}
.eliminate-paper-block.isMobile .eliminate-paper-right-block {
  position: absolute;
  top: 0;
  bottom: unset;
  width: 100%;
}
.eliminate-paper-block.isMobile .eliminate-paper-right-block .eliminate-paper-right-svg {
  width: unset;
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/PreFooterBlock/styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,4DAAA;EACA,6DAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;EACA,kBAAA;AACN;AAGE;EACE,UAAA;EACA,kBAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAII;EACE,UAAA;EACA,aAAA;EACA,WAAA;EACA,wBAAA;AAFN;AAIM;EACE,uBAAA;AAFR;AAMI;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;AAJN;AAMM;EACE,uBAAA;AAJR;AASE;EACE,UAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAPJ;AASI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAPN;AAUI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AARN;AAWI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,4DAAA;EACA,6DAAA;EACA,4BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AATN;;AAcA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAXF;AAaE;EACE,WAAA;EACA,YAAA;AAXJ;AAcE;EACE,UAAA;EACA,OAAA;EACA,wBAAA;EACA,UAAA;AAZJ;AAcI;EACE,uBAAA;AAZN;AAgBE;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAdJ;AAgBI;EACE,wBAAA;AAdN;;AAmBA;EACE,kBAAA;AAhBF;AAkBE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAhBJ;AAkBI;EACE,YAAA;EACA,aAAA;EACA,wBAAA;AAhBN;AAmBI;EACE,SAAA;EACA,YAAA;EACA,wBAAA;AAjBN;AAoBI;EACE,SAAA;EACA,UAAA;EACA,wBAAA;AAlBN;AAqBI;EACE,SAAA;EACA,SAAA;EACA,uBAAA;AAnBN;AAuBE;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AArBJ;AAuBI;EACE,YAAA;EACA,aAAA;AArBN;AAyBE;EACE,4BAAA;EACA,WAAA;AAvBJ;AAyBI;EACE,eAAA;EACA,iBAAA;AAvBN;AA0BI;EACE,eAAA;EACA,iBAAA;AAxBN;AA2BI;EACE,gBAAA;EACA,oBAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;AA3BJ;AA6BI;EACE,YAAA;EACA,aAAA;AA3BN","sourcesContent":[".eliminate-paper-block {\n  width: 100%;\n  border-radius: 20px;\n  background-color: #040e46;\n  display: flex;\n  margin-top: 20px;\n\n  .eliminate-paper-card {\n    height: 144px;\n    width: 120px;\n    background-color: #fff;\n    box-shadow: 0px 6px 10px -4px #0f17281a;\n    box-shadow: 0px 18px 32px -4px #0f172838;\n    border-radius: 10px;\n    padding: 24px 15px;\n    text-align: center;\n    position: absolute;\n\n    .eliminate-paper-card-text {\n      margin-top: 6px;\n      text-align: center;\n    }\n  }\n\n  .eliminate-paper-left-block {\n    width: 25%;\n    position: relative;\n\n    .eliminate-paper-left-svg {\n      width: 100%;\n      height: auto;\n    }\n\n    .eliminate-paper-customize-processes-card {\n      z-index: 1;\n      bottom: -20px;\n      left: 41.2%;\n      transform: rotate(-8deg);\n\n      svg {\n        transform: rotate(8deg);\n      }\n    }\n\n    .eliminate-paper-staff-education-card {\n      z-index: 2;\n      bottom: 76px;\n      left: 68.5%;\n      transform: rotate(-3deg);\n\n      svg {\n        transform: rotate(3deg);\n      }\n    }\n  }\n\n  .eliminate-paper-center-block {\n    width: 50%;\n    padding: 100px 40px;\n    color: #fff;\n    text-align: center;\n\n    .eliminate-paper-title {\n      font-size: 46px;\n      font-weight: 600;\n      line-height: 120%;\n    }\n\n    .eliminate-paper-subtitle {\n      margin-top: 24px;\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 180%;\n    }\n\n    .request-demo-btn {\n      margin-top: 60px;\n      margin-left: auto;\n      margin-right: auto;\n      background-color: #3571d6;\n      border-radius: 8px;\n      width: 200px;\n      height: 45px;\n      border: none;\n      border-bottom: 2px solid #040e46;\n      box-shadow: 0px 6px 10px -4px #0f17281a;\n      box-shadow: 0px 18px 32px -4px #0f172838;\n      padding: 12px 24px 12px 24px;\n      color: #fff;\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 150%;\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n\n.eliminate-paper-right-block {\n  width: 25%;\n  display: flex;\n  align-items: end;\n  position: relative;\n\n  .eliminate-paper-right-svg {\n    width: 100%;\n    height: auto;\n  }\n\n  .eliminate-paper-compliance-card {\n    top: -43px;\n    left: 0;\n    transform: rotate(-7deg);\n    z-index: 2;\n\n    svg {\n      transform: rotate(7deg);\n    }\n  }\n\n  .eliminate-paper-file-card {\n    top: 45px;\n    left: 30%;\n    z-index: 3;\n    transform: rotate(2deg);\n\n    svg {\n      transform: rotate(-2deg);\n    }\n  }\n}\n\n.eliminate-paper-block.isMobile {\n  position: relative;\n\n  .eliminate-paper-card {\n    width: 110px;\n    height: auto;\n    padding: 18px 12px;\n\n    &.eliminate-paper-customize-processes-card {\n      left: 23.43%;\n      bottom: -14px;\n      transform: rotate(-8deg);\n    }\n\n    &.eliminate-paper-staff-education-card {\n      left: 49%;\n      bottom: 35px;\n      transform: rotate(-3deg);\n    }\n\n    &.eliminate-paper-compliance-card {\n      left: 22%;\n      top: -14px;\n      transform: rotate(-7deg);\n    }\n\n    &.eliminate-paper-file-card {\n      left: 50%;\n      top: 14px;\n      transform: rotate(2deg);\n    }\n  }\n\n  .eliminate-paper-left-block {\n    position: absolute;\n    bottom: 0;\n    text-align: right;\n    width: 100%;\n\n    .eliminate-paper-left-svg {\n      width: unset;\n      height: 200px;\n    }\n  }\n\n  .eliminate-paper-center-block {\n    padding: 167px 20px 0px 20px;\n    width: 100%;\n\n    .eliminate-paper-title {\n      font-size: 36px;\n      line-height: 120%;\n    }\n\n    .eliminate-paper-subtitle {\n      font-size: 20px;\n      line-height: 160%;\n    }\n\n    .request-demo-btn {\n      margin-top: 40px;\n      margin-bottom: 200px;\n    }\n  }\n\n  .eliminate-paper-right-block {\n    position: absolute;\n    top: 0;\n    bottom: unset;\n    width: 100%;\n\n    .eliminate-paper-right-svg {\n      width: unset;\n      height: 200px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
